/**
 * Üretilen bir bağlantıyı gösteren ve paylaştıran kutu.
 *
 * Ölçüm bağlantısı da veli bağlantısı da ödev bağlantısı da aynı
 * kalıp: tek kullanımlık, süreli, uygulayıcı eliyle iletiliyor. Tek
 * yerde durması, birinde yapılan düzeltmenin diğerinde
 * unutulmamasını sağlıyor — QR kodu da bu yüzden buraya eklendi ve
 * üç bağlantının hepsinde birden çalışıyor.
 */

import { useState } from 'react'
import { whatsappAdresi } from './api'
import { Kare, KareBuyuk } from './Kare'

export function Baglanti({
  adres,
  mesaj,
  telefon,
  not,
  /**
   * Çocuğun cihazında açılacak bağlantılarda QR öne çıkıyor.
   *
   * Veli bağlantısında ise WhatsApp öne çıkıyor: o bağlantı başka
   * bir şehirdeki telefona gidiyor, karşıda okutacak bir ekran yok.
   */
  kare = false,
}: {
  adres: string
  /** WhatsApp'a hazır gelecek metin; bağlantı sonuna eklenir */
  mesaj: string
  /** Varsa doğrudan bu numaraya açılır */
  telefon?: string | null
  not?: string
  kare?: boolean
}) {
  const [kopyalandi, setKopyalandi] = useState(false)
  const [buyuk, setBuyuk] = useState(false)

  return (
    <>
      {kare && (
        <div
          style={{
            display: 'flex',
            gap: 14,
            alignItems: 'center',
            flexWrap: 'wrap',
            marginBottom: 10,
          }}
        >
          <Kare adres={adres} />
          <div>
            <p style={{ margin: '0 0 6px' }}>
              <strong>Tabletin kamerasıyla bu kodu okutun.</strong>
            </p>
            <p className="alt" style={{ margin: '0 0 8px' }}>
              Kamera uygulaması ya da kod okuyucu yeter; bağlantıyı yazmak gerekmiyor. Kod
              bağlantının kendisi: tek kullanımlık ve süreli.
            </p>
            <button type="button" onClick={() => setBuyuk(true)}>
              Büyüt
            </button>
          </div>
        </div>
      )}

      <div className="baglanti">
        <code>{adres}</code>
        <button
          onClick={() => {
            void navigator.clipboard
              .writeText(adres)
              .then(() => setKopyalandi(true))
              .catch(() => setKopyalandi(false))
          }}
        >
          {kopyalandi ? 'Kopyalandı ✓' : 'Kopyala'}
        </button>
        <a
          href={whatsappAdresi(telefon, `${mesaj}\n\n${adres}`)}
          target="_blank"
          rel="noreferrer"
        >
          <button type="button">WhatsApp'ta gönder</button>
        </a>
        {!kare && (
          <button type="button" onClick={() => setBuyuk(true)}>
            QR kodu
          </button>
        )}
      </div>

      {not && (
        <p className="alt" style={{ margin: '10px 0 0' }}>
          {not}
        </p>
      )}

      {buyuk && <KareBuyuk adres={adres} onKapat={() => setBuyuk(false)} />}
    </>
  )
}
